import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'idp-modify-desktop-skeleton-mach-core',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modify-desktop-skeleton-mach-core.component.html'
})
export class ModifyDesktopSkeletonMachCoreComponent {}
